import {
  DashboardDataTableSortDirection,
  type DashboardDataTableSortState,
} from '@shigo-ui/dashboard-ui';

import type { NetworkPerformanceRow } from '../../model';
import { NetworkPerformanceSortKey } from './columns';

type SortableValue = string | number | null;

export function sortNetworkPerformanceRows(
  rows: NetworkPerformanceRow[],
  sort: DashboardDataTableSortState | undefined,
) {
  if (!sort || !isNetworkPerformanceSortKey(sort.key)) return rows;
  const key = sort.key;
  const direction = sort.direction === DashboardDataTableSortDirection.Asc ? 1 : -1;

  return [...rows].sort((left, right) => {
    const leftValue = resolveSortValue(left, key);
    const rightValue = resolveSortValue(right, key);
    if (leftValue === null) return rightValue === null ? 0 : 1;
    if (rightValue === null) return -1;
    return compareValues(leftValue, rightValue) * direction;
  });
}

function resolveSortValue(row: NetworkPerformanceRow, key: NetworkPerformanceSortKey) {
  return row[key];
}

function compareValues(left: Exclude<SortableValue, null>, right: Exclude<SortableValue, null>) {
  if (left === right) return 0;
  if (typeof left === 'number' && typeof right === 'number') return left - right;
  return String(left).localeCompare(String(right), undefined, { numeric: true });
}

function isNetworkPerformanceSortKey(value: string): value is NetworkPerformanceSortKey {
  return Object.values<string>(NetworkPerformanceSortKey).includes(value);
}
